import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { BackendApiService } from 'src/app/core/services/backend-api';
import { AlertType } from 'src/app/shared/components/alert/alert.component';
import { DropDownOptions, StoreDropdowns } from 'src/app/shared/models/app-models';
import { MPMMSInformation } from 'src/app/shared/models/app-models/MPMMSInformation.model';
import { SourcedItem } from 'src/app/shared/models/app-models/SourcingOutcome.model';
import { SummaryDropdown } from '../rfq-summary.component';

@Component({
  selector: 'app-complete-dialog',
  templateUrl: './complete-dialog.component.html',
  styleUrls: ['./complete-dialog.component.scss']
})
export class CompleteDialogComponent {
  destroy$: Subject<boolean> = new Subject<boolean>();
  isAllItemsHavePO!: boolean;
  isAnyItemSelectedForReasonForAbortion: boolean | null = null;
  allItemsHaveReason: boolean | null = null;
  type: string | null = null;
  rfqItems: SourcedItem[] = [];
  selected: SourcedItem[] = [];
  mpMmsInformation: MPMMSInformation[] = [];
  filteredItemsWithoutPO: SourcedItem[] = []; 
  ReasonForAbortionDropDown: SummaryDropdown[] = []
  selectedReasonForAbort: DropDownOptions | null = null;
  constructor(private BackendApi: BackendApiService, private dialogRef: MatDialogRef<CompleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store<{ dp: StoreDropdowns }>,
  ) {
    this.store
      .select('dp')
      .pipe(takeUntil(this.destroy$))
      .subscribe((dp: StoreDropdowns) => {
        this.ReasonForAbortionDropDown = dp.RFQAbortReasons;
      });
    this.rfqItems = this.data.rfqItems;
    this.type = this.data.type;
    this.mpMmsInformation = this.data.mpMmsInformation;

    const flattenedMmsData = this.mpMmsInformation.flat();

    // Group MMS data by ItemNumber
    const groupedMpMmsData = flattenedMmsData.reduce((acc, mms) => {
      if (!acc[mms.CopiedFromItemNumber]) {
        acc[mms.CopiedFromItemNumber] = [];
      }
      acc[mms.CopiedFromItemNumber].push(mms);
      return acc;
    }, {} as { [key: number]: any[] });
    // console.log("Complete dialog grouped mms data", groupedMpMmsData);
    // console.log("Complete dialog this.rfqItems", this.rfqItems);
    
    this.filteredItemsWithoutPO = this.rfqItems.filter(item => {
      const itemMmsData = groupedMpMmsData[item.PurchaseItemId] || [];
      if (itemMmsData.length === 0) {
        return true;
      }
    
      const hasPO = itemMmsData.some(mms => mms.DocumentNumber && mms.DocumentNumber.trim() !== '');
      const mismatchedQty = itemMmsData.some(mms => mms.Quantity !== item.Quantity);
    
      return !hasPO || (hasPO && mismatchedQty);
    });
    // this.filteredItemsWithoutPO = this.rfqItems; // for testing purposes only
    // console.log("Filtered Items Without PO:", this.filteredItemsWithoutPO);
  }

  ngOnInit() {
    // this.getAbortReasons();
    // console.log("this.rfqItems", this.rfqItems);
    // console.log("this.mpmmsinfo", this.mpMmsInformation);
  }

  onAbortReasonSelected(selectedReasonForAbort: DropDownOptions) {
    this.selectedReasonForAbort = selectedReasonForAbort;
    // console.log("Selected Reason for Abort:", this.selectedReasonForAbort);
  }

  onApplyButtonClick() {
    // console.log("Apply to checked items button is clicked!")
    if (this.selectedReasonForAbort && this.selected.length > 0) {
      this.isAnyItemSelectedForReasonForAbortion = true;
      this.selected.forEach(item => {
        item.ReasonForAbort = this.selectedReasonForAbort;
      });

      this.filteredItemsWithoutPO = this.filteredItemsWithoutPO.map(item => {
        if (this.selected.some(selectedItem => selectedItem.PurchaseItemId === item.PurchaseItemId)) {
          item.ReasonForAbort = this.selectedReasonForAbort;
        }
        return item;
      })
    } else if (this.selected.length === 0) {
      this.isAnyItemSelectedForReasonForAbortion = false;
    }
    // console.log("this.selected", this.selected);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onComplete(): void {
    console.log("Complete is click!");
    // console.log("complete dialog oncomplete is all items has PO", this.isAllItemsHavePO);
    console.log(this.filteredItemsWithoutPO);


    if (!this.isAllItemsHavePO) {
      this.checkedAllItemsHaveReason();

      if (this.allItemsHaveReason) {
        this.dialogRef.close(this.filteredItemsWithoutPO);
      } 
    } else {
      this.dialogRef.close([]);
    }

    return;
  }

  handleSelection(list: SourcedItem[]) {
    this.selected = list;
  }

  updateAllItemsHavePO(allItemsHavePo: boolean) {
    setTimeout(() => {
      this.isAllItemsHavePO = allItemsHavePo;
    });
  }

  checkedAllItemsHaveReason() {
    this.allItemsHaveReason = true;
    
    if (!this.isAllItemsHavePO) {
      for (let i = 0; i < this.filteredItemsWithoutPO.length; i++) {
        if (!this.filteredItemsWithoutPO[i].ReasonForAbort) {
          this.allItemsHaveReason = false;
          break;
        }
      }
    }
    // console.log("checkedAllItemsHaveReason", this.allItemsHaveReason);
  }

  public get alertType(): typeof AlertType {
      return AlertType;
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

}
